class ProductDescriptionReadMore extends HTMLElement {
  constructor() {
    super();
    this.content = this.querySelector('[data-read-more-content]');
    this.toggleButton = this.querySelector('[data-read-more-toggle]');
    this.collapsedText = this.querySelector('[data-read-more-text-collapsed]');
    this.expandedText = this.querySelector('[data-read-more-text-expanded]');
    this.collapsedHeight = parseInt(this.dataset.readMoreHeight || 150, 10);

    // Se o conteúdo e o botão existirem, inicialize
    if (this.content && this.toggleButton) {
      this.toggleButton.addEventListener('click', this.toggle.bind(this));
      this.init();
    }
  }

  init() {
    // Verifique se o conteúdo é maior que a altura colapsada para exibir o botão
    // Use setTimeout para garantir que o render do DOM esteja completo
    setTimeout(() => {
      if (this.content.scrollHeight > this.collapsedHeight) {
        this.classList.add('collapsed');
        this.content.style.setProperty('--read-more-collapsed-height', `${this.collapsedHeight}px`);
        this.toggleButton.setAttribute('aria-expanded', 'false');
        this.collapsedText.classList.remove('hidden');
        this.expandedText.classList.add('hidden');
        this.toggleButton.style.display = ''; // Garante que o botão esteja visível
      } else {
        // Se o conteúdo é menor que a altura colapsada, não precisa de toggle
        this.toggleButton.style.display = 'none';
        this.classList.add('expanded'); // Garante que não há overlay ou max-height
      }
    }, 0);
  }

  toggle() {
    const isExpanded = this.classList.contains('expanded');
    if (isExpanded) {
      this.classList.remove('expanded');
      this.classList.add('collapsed');
      this.toggleButton.setAttribute('aria-expanded', 'false');
      this.collapsedText.classList.remove('hidden');
      this.expandedText.classList.add('hidden');
    } else {
      this.classList.remove('collapsed');
      this.classList.add('expanded');
      this.toggleButton.setAttribute('aria-expanded', 'true');
      this.collapsedText.classList.add('hidden');
      this.expandedText.classList.remove('hidden');
    }
  }
}

customElements.define('product-description-read-more', ProductDescriptionReadMore);